import styles from './index.module.less'
import RankingOne from '@/assets/image/gea/ranking_one.svg'
import RankingTwo from '@/assets/image/gea/ranking_two.svg'
import RankingThree from '@/assets/image/gea/ranking_three.svg'
import classNames from 'classnames'
import { Region_List_Item, Region_List_Treasure, type RegionState } from '@/api/region/types'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useTranslation } from 'react-i18next'
import MeToolTip from '@/components/MeToolTip'
import { formatDecimalCus, formatValue, ugagToGag, ugeaToGea2 } from '@/utils/number'
import { isEmptyOrNil } from '@/utils'
import { useMemo } from 'react'

const SecondaryCard = ({ index = 1, cardInfo }: { index: number; cardInfo: Region_List_Item }) => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()

  const regionId = useMemo(() => {
    if (isEmptyOrNil(cardInfo.regionId)) return '-'
    if (cardInfo.regionId === 'global_village') {
      return t('explorer_266')
    }
    return cardInfo.regionId.toUpperCase() + '-Zone'
  }, [cardInfo.regionId])

  const getTreasureAmount = (val: Region_List_Treasure[], denom: 'ugag' | 'ugea') => {
    if (!val.length) return ''
    if (denom === 'ugag') {
      return val.find((item) => item.denom === 'ugag')?.amount
    }
    return val.find((item) => item.denom === 'ugea')?.amount
  }

  return (
    <div className={styles.wrap}>
      <div className={classNames('sort_area', `sort_area_bg${index < 5 ? index : 3}`)}>
        {index < 4 && (
          <img src={index === 1 ? RankingOne : index === 2 ? RankingTwo : RankingThree} alt="" />
        )}
        <div className="sort_value">{index}</div>
      </div>
      <div className="data_wrap">
        <div className="data_item">
          {/* 区域名称 */}
          <div className="data_item_name">{t('explorer_52')}</div>
          <div
            onClick={() => {
              if (cardInfo.regionId) {
                navigate(`/countryRegion/${cardInfo.regionId}`)
              }
            }}
            className={classNames({
              data_item_value: true,
              text_blue: true,
            })}
          >
            {regionId}
          </div>
        </div>
        <div className="data_item">
          {/* 状态 缺失 */}
          <div className="data_item_name">{t('explorer_53')}</div>
          <div className="data_item_value">
            <div
              className={classNames({
                status: true,
                normal: true,
              })}
            >
              {/* 能查到就是正常 正常 */}
              {t('explorer_57')}
            </div>
          </div>
        </div>
        {/* <div className="data_item">
          已认证地址
          <div className="data_item_name">{t('explorer_16')}</div>
          <div className="data_item_value">{formatValue(cardInfo.current_kyc_amount, true)}</div>
        </div> */}
        {/* <div className="data_item">
          当日签到
          <div className="data_item_name">
            <MeToolTip title={t('explorer_54')} tip={t('explorer_126')}></MeToolTip>
          </div>
          <div className="data_item_value">
            {formatValue(cardInfo.checkin_today_count?.check_in_count, true) === '-'
              ? '0'
              : formatValue(cardInfo.checkin_today_count?.check_in_count, true)}
          </div>
        </div> */}
        <div className="data_item">
          <div className="data_item_name">
            {/* 质押总量 */}
            {/* <MeToolTip title={t('explorer_55')} tip={t('explorer_127')}></MeToolTip> */}
            {/* 金库总量GEA */}
            <MeToolTip title={`${t('explorer_303')}`} tip={t('explorer_303_desc1')}></MeToolTip>
          </div>
          <div className="data_item_value">
            <span>{ugeaToGea2(getTreasureAmount(cardInfo.treasure, 'ugea'), true, 0).value}</span>
            <span className="sgin">
              {ugeaToGea2(getTreasureAmount(cardInfo.treasure, 'ugea')).sigin}
            </span>
          </div>
        </div>
        <div className="data_item">
          <div className="data_item_name">
            {/* 质押总量 */}
            {/* <MeToolTip title={t('explorer_55')} tip={t('explorer_127')}></MeToolTip> */}
            {/* 金库总量GAG */}
            <MeToolTip title={`${t('explorer_303')}`} tip={t('explorer_303_desc2')}></MeToolTip>
          </div>
          <div className="data_item_value">
            <span>{ugagToGag(getTreasureAmount(cardInfo.treasure, 'ugag'), true, 0).value}</span>
            <span className="sgin">
              {ugagToGag(getTreasureAmount(cardInfo.treasure, 'ugag'), true, 0).sigin}
            </span>
          </div>
        </div>
        <div className="data_item">
          {/* AGR 质押总量 */}
          <div className="data_item_name">
            <MeToolTip title={t('explorer_299')} tip={t('explorer_299_desc')}></MeToolTip>
          </div>
          <div className="data_item_value">
            <span>{ugeaToGea2(cardInfo.currentKycTotalUgea, true, 0).value}</span>
            <span className="sgin">{ugeaToGea2(cardInfo.currentKycTotalUgea).sigin}</span>
          </div>
        </div>
        <div className="data_item">
          {/* AGE质押 总量 灵活锁仓*/}
          <div className="data_item_name">
            <MeToolTip title={t('explorer_300')} tip={t('explorer_300_desc')}></MeToolTip>
          </div>
          <div className="data_item_value">
            <span>{ugeaToGea2(cardInfo.currentLockUpTotalUgea, true, 0).value}</span>
            <span className="sgin">{ugeaToGea2(cardInfo.currentLockUpTotalUgea).sigin}</span>
          </div>
        </div>
        <div className="data_item">
          {/* AGD质押 总量 灵活期限 */}
          <div className="data_item_name">
            <MeToolTip title={t('explorer_301')} tip={t('explorer_301_desc')}></MeToolTip>
          </div>
          <div className="data_item_value">
            <span>{ugeaToGea2(cardInfo.currentNormalDelegationTotalUgea, true, 0).value}</span>
            <span className="sgin">
              {ugeaToGea2(cardInfo.currentNormalDelegationTotalUgea).sigin}
            </span>
          </div>
        </div>
        <div className="data_item">
          {/* AGS质押 总量 固定期限*/}
          <div className="data_item_name">
            <MeToolTip title={t('explorer_302')} tip={t('explorer_302_desc')}></MeToolTip>
          </div>
          <div className="data_item_value">
            <span>{ugeaToGea2(cardInfo.currentFixedDelegationTotalUgea, true, 0).value}</span>
            <span className="sgin">
              {ugeaToGea2(cardInfo.currentFixedDelegationTotalUgea).sigin}
            </span>
          </div>
        </div>

        {/* GEA总量 */}
        {/* <div className="data_item">
          <div className="data_item_name">{t('explorer_264')}</div>
          <div className="data_item_value">
            <span>{ugeaToGea2(cardInfo?.balance_base_account?.ugea_amount, true, 0).value}</span>
            <span className="sgin">
              {ugeaToGea2(cardInfo?.balance_base_account?.ugea_amount, true, 0).sigin}
            </span>
          </div>
        </div> */}
        {/* GAG 总量 */}
        {/* <div className="data_item">
          <div className="data_item_name">{t('explorer_49')}</div>
          <div className="data_item_value">
            {!isEmptyOrNil(cardInfo.current_occupy_ans)
              ? formatValue(Math.trunc(cardInfo.current_occupy_ans * 160000), true)
              : '-'}
          </div>
        </div> */}
        {/* ANS 总量 */}
        {/* <div className="data_item">
          <div className="data_item_name">
            <MeToolTip title={t('explorer_50')} tip={t('explorer_131')}></MeToolTip>
          </div>
          <div className="data_item_value">
            {formatValue(Math.trunc(cardInfo.current_occupy_ans), true)}
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default SecondaryCard
